/**
 * Lookup for the generated art in this folder (see ASSET_BRIEF.md).
 *
 * Files are discovered at build time, so an asset that hasn't been made
 * yet is simply undefined and every consumer keeps its procedural
 * fallback. Vite hashes each file into /assets/, which the deploy serves
 * with a year-long immutable cache.
 */

const urls: Record<string, string> = {};
for (const [path, url] of Object.entries(
  // Raw generations (_raw/) and scratch previews (_*) are never shipped.
  import.meta.glob(["./**/*.{webp,png}", "!./_raw/**", "!./**/_*"], { eager: true, query: "?url", import: "default" }),
)) {
  // "./rite/rite-floor.webp" → "rite/rite-floor.webp".
  urls[path.slice(2)] = url as string;
}

/** URL for e.g. `"rite/nebula.webp"`, or undefined if not generated. */
export function generatedArt(path: string): string | undefined {
  return urls[path];
}
